import React, { useState, useEffect } from "react";

const CustomTimer = ({ startTime = 0, className, isTimerRunning }) => {
  // console.log("🚀 ~ CustomTimer ~ startTime:", startTime)
  const [time, setTime] = useState(0);

  useEffect(() => {
    setTime(startTime)
  },[startTime])

  useEffect(() => {
    let timer;
    if (isTimerRunning) {
      timer = setInterval(() => {
        setTime((prevTime) => prevTime + 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [isTimerRunning]);

  // const formatTime = (seconds) => {
  //   const hrs = Math.floor(seconds / 3600);
  //   const mins = Math.floor((seconds % 3600) / 60);
  //   const secs = seconds % 60;
  //   return `${hrs}:${mins}:${secs}`;
  // };

  const formatTime = (seconds) => {
    const hrs = String(Math.floor(seconds / 3600)).padStart(2, "0");
    const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
    const secs = String((seconds % 60).toFixed()).padStart(2, "0");
    return `${hrs}:${mins}:${secs}`;
  };

  return (
    <div style={{ textAlign: "center" }}>
      <h2 className={className}>{formatTime(time)}</h2>
      {/* <h2 className={className}>
        <span>{days}</span>:<span>{hours}</span>:<span>{minutes}</span>:
        <span>{seconds}</span>
      </h2> */}

      {/* <button onClick={() => setIsRunning(true)}>Start</button> */}
      {/* <button onClick={() => setIsRunning(false)}>Pause</button> */}
      {/* <button
        onClick={() => {
          setTime(0);
          setIsRunning(false);
        }}
      >
        Reset
      </button> */}
    </div>
  );
};

export default CustomTimer;